import WORKOUT_DIFFICULTY from '../../../../../modules/workout/model/constants/difficulty'
import isInPlanWorkoutUtil from '../../../../../modules/workout/model/utils/is-in-plan'
import addWorkoutLogPlanAction from '../../../../plans/actions/add-workout-log'
import getReduxSelector from '../../../../redux/selectors/get'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { START_WORKOUT_PATH } from '../../../../start-workout/constants'
// import createPostAction from '../../../../posts/actions/create'
//
import cloneIfCantEditWorkoutAction from '../clone-if-cant-edit'
import saveWorkoutAction from '../save'
import updateCurrentWorkoutAction from '../set-current'
import setSuggestedWorkoutAction from '../set-suggested'
import updateCompletionTimeWorkoutAction from '../update-completion-time'
import updateDifficultyWorkoutAction from '../update-difficulty'
import updateLoggedAtWorkoutAction from '../update-logged-at'
import updateNotesWorkoutAction from '../update-notes'
import getByIdWorkoutSelector from '../../selectors/get-by-id'
import getCurrentWorkoutSelect from '../../selectors/get-current'
import getStartedWorkoutSelect from '../../selectors/get-started'

function logWorkoutAction (options = {}) {
  return async (dispatch, getState) => {
    dispatch(setSuggestedWorkoutAction())

    const { id } = options
    let workout
    if (id) {
      workout = getByIdWorkoutSelector(id)(getState())
    } else {
      workout = options.workout ||
        (
          getStartedWorkoutSelect(getState()) ||
          getCurrentWorkoutSelect(getState())
        )
    }

    const workoutLog = await dispatch(cloneIfCantEditWorkoutAction({
      workout
    }))

    // let workoutLog = workout
    // if (shouldClone) {
    //   workout = await dispatch(cloneIfCantEditWorkoutAction({
    //     workout
    //   }))
    //
    //   if (isNewReduxUtil(workout)) {
    //     await dispatch(saveWorkoutAction(getIdReduxUtil(workout)))
    //   }
    //
    //   await runAfterDelayPromisifiedPerformanceUtil()
    //
    //   workoutLog = await dispatch(cloneAndSetWorkoutAction({
    //     workout
    //   }))
    // } else {
    // workoutLog = workout
    // }

    dispatch(updateCurrentWorkoutAction(workoutLog))

    const totalCompletionTime = getReduxSelector(START_WORKOUT_PATH.TOTAL_TIME_ELAPSED)(
      getState()) || 0
    dispatch(updateCompletionTimeWorkoutAction(Math.round(totalCompletionTime /
      1000)))

    dispatch(updateLoggedAtWorkoutAction())

    dispatch(updateDifficultyWorkoutAction(WORKOUT_DIFFICULTY.GOOD))

    dispatch(updateNotesWorkoutAction())

    dispatch(saveWorkoutAction(getIdReduxUtil(workoutLog)))

    if (isInPlanWorkoutUtil(workoutLog)) {
      dispatch(addWorkoutLogPlanAction(workoutLog))
    }

    // dispatch(
    //   createPostAction({
    //     type: POST_TYPE.WORKOUT_LOGGED,
    //     attachment: workoutLog
    //   })
    // )

    return workoutLog
  }
}

export { logWorkoutAction }
